import { apolloClient, apolloCustomerClient } from '@/plugins/apollo';
import addVehicleMutation from '@/graphql/vehicle/add.gql';
import editVehicleMutation from '@/graphql/vehicle/edit.gql';
import removeVehicleMutation from '@/graphql/vehicle/remove.gql';
import infoQuery from '@/graphql/vehicle/info.gql';
import store from '@/store';

export default {
  /**
   * Add vehicle.
   *
   * @param {String} licensePlate
   *
   * @returns {Object}
   */
  async add(licensePlate) {
    const response = await apolloCustomerClient.mutate({
      mutation: addVehicleMutation,
      variables: {
        licensePlate,
      },
    });

    const vehicle = response.data.AddVehicle;

    return vehicle;
  },
  /**
   * Edit vehicle.
   *
   * @param {Object} vehicle
   */
  async edit(vehicle) {
    const response = await apolloCustomerClient.mutate({
      mutation: editVehicleMutation,
      variables: {
        vehicle: {
          id: vehicle.id,
          tires: vehicle.tires,
          mileage: vehicle.mileage,
          lease: vehicle.lease,
        },
      },
    });

    const index = store.user.customer.vehicles.findIndex((v) => v.id === vehicle.id);
    store.user.customer.vehicles[index] = response.data.UpdateVehicle;

    return store.user.customer.vehicles[index];
  },

  /**
   * Remove vehicle.
   *
   * @param {Number} id
   *
   * @returns {Boolean}
   */
  async remove(id) {
    const response = await apolloCustomerClient.mutate({
      mutation: removeVehicleMutation,
      variables: {
        id,
      },
    });

    store.user.customer.vehicles.splice(
      store.user.customer.vehicles.findIndex((v) => v.id === id),
      1,
    );

    return response.data.RemoveVehicle;
  },

  /**
   * Vehicle info.
   *
   * @param {String} licensePlate
   *
   * @returns {Object}
   */
  async info(licensePlate) {
    const response = await apolloClient.query({
      query: infoQuery,
      variables: {
        id: licensePlate,
      },
      fetchPolicy: 'no-cache',
    });

    return response.data.vehicle;
  },
};
